// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"02f91c24","298":"254fb618","453":"766c19f9"}[chunkId] + ".chunk.js";
};